import { bindable, bindingMode, computedFrom, containerless, autoinject } from "aurelia-framework";

import nameof from "../../../common/nameof";
import { IGrouping } from "../../../interfaces/form-builder/i-element";
import { IAncestorSettings } from "../../../interfaces/form-builder/i-input-options";
import { NoteDataManager } from "../note-data-manager";
import { getColumnClasses } from "../../../common/utilities/column-classes";
import { ElementTypesEnum } from "../element-types-enum";
import { IInput } from "../../../interfaces/form-builder/i-input";

// INFO: Do not name it section since there is section tag and
// Aurelia will override that section tag
// The section tag was redirected to this component
// since all components are custom elements in Aurelia
@containerless
@autoinject
export class SectionGroup {
    @bindable({ defaultBindingMode: bindingMode.twoWay })
    public element: IGrouping;
    @bindable({ defaultBindingMode: bindingMode.toView })
    public ancestorSettings: IAncestorSettings;
    private _noteDataManager: NoteDataManager;
    private _inputCache = new WeakMap<IGrouping, boolean>();
    public tooltip: string;
    public isAi: boolean = false;

    @computedFrom(nameof<SectionGroup>("element"))
    public get columnsClasses(): string {
        let columns = this.element.columns;
        return getColumnClasses(columns);
    }

    @computedFrom(nameof<SectionGroup>("element"))
    public get sectionTypeClass(): string {
        if (this.element.sectionType) {
            return `${this.element.sectionType.toLowerCase()}-section`;
        } else {
            return "";
        }
    }

    public constructor(noteDataManager: NoteDataManager) {
        this._noteDataManager = noteDataManager;
    }

    public async attached() {
        this.tooltip = await this._noteDataManager.getTooltip(this.element.name);
        this.isAi = this.checkGroupForAIInput(this.element);
    }

    private checkGroupForAIInput(groupedElement: IGrouping) {
        if (this._inputCache.has(groupedElement)) {
            return this._inputCache.get(groupedElement);
        }
        for (const element of groupedElement?.elements) {
            if (element.elementType == ElementTypesEnum.Input) {
                if (this._noteDataManager.isAiInput(element.name)) {
                    this._inputCache.set(groupedElement, true);
                    return true;
                }
            } else if (element.elementType === ElementTypesEnum.Grouping) {
                let checkAIResult = this.checkGroupForAIInput(element as IGrouping);
                this._inputCache.set(groupedElement, checkAIResult);
                if (checkAIResult) {
                    return true;
                }
            }
        }
        this._inputCache.set(groupedElement, false);
        return false;
    }
}
